module.exports = __webpack_public_path__ + "img/twitter.706f2221.svg";